import { FunctionComponent } from "react"
import { Alert, Button, Card, Col, Row } from "react-bootstrap"
import Container from "react-bootstrap/Container"
import { useNavigate, useParams } from "react-router-dom"
import PrivateComponent from "../components/PrivateComponent"
import { Group, RouterExtended } from "../data/models"
import useQuery from "../hooks/useQuery"

interface IRouterPage {}
const RouterPage: FunctionComponent<IRouterPage> = () => {
	const navigate = useNavigate()
	const params = useParams()
	const routerId = params.routerId
	const routerQuery = useQuery<void, RouterQueryResponse>(`${process.env.REACT_APP_KNIT_URL}routers?id=${routerId}`)
	//
	const router = routerQuery.data?.routers?.[0]
	const error = routerQuery.error
	//
	if (routerQuery.loading) {
		return (
			<Container>
				<h2 className="text-center mt-4">Router</h2>
				<div className="text-center">Loading</div>
			</Container>
		)
	}
	if (routerQuery.error) {
		return (
			<Container>
				<h2 className="text-center mt-4">Router</h2>
				<Alert variant={"warning"}>{routerQuery.error}</Alert>
				<Col xs="auto">
					<Button variant="secondary" onClick={() => navigate(-1)} className="mb-4">
						Back
					</Button>
				</Col>
			</Container>
		)
	}
	return (
		<Container>
			<h2 className="text-center mt-4">
				{router?.propertyName} {router?.unitName}
			</h2>
			{error && <Alert variant={"warning"}>{error}</Alert>}
			<Row xs={1} md={2} lg={3} className="g-4 mt-4">
				<Col>
					<Card>
						<Card.Header>WIFI</Card.Header>
						<Card.Body>
							<Card.Text>{router?.wifiName}</Card.Text>
							<Card.Text>Password: {router?.wifiPassword}</Card.Text>
							<Button className="mx-2 mt-2" onClick={() => navigate(`change-password`)}>
								Change WIFI Password
							</Button>
						</Card.Body>
					</Card>
				</Col>
				<Col>
					<Card>
						<Card.Header>Current Plan</Card.Header>
						<Card.Body>
							<Card.Text>{router?.currentTenantName}</Card.Text>
							<Card.Text>{router?.currentPlanName}</Card.Text>
							<Card.Text>
								{!router?.currentStartDate
									? "No plan active"
									: router.currentEndDate
									? `Continues through ${router.currentEndDate}`
									: `Continues until canceled`}
							</Card.Text>
							{!router?.currentStartDate && (
								<Button className="mx-2 mt-2" onClick={() => navigate("start-now")}>
									Start Service Now
								</Button>
							)}
							{router?.currentEndDate && (
								<Button className="mx-2 mt-2" onClick={() => navigate("change-end")}>
									Change End of Service
								</Button>
							)}
							{router?.currentEndDate && !router.nextStartDate && (
								<Button className="mx-2 mt-2" onClick={() => navigate("cancel-end")}>
									Cancel End of Service
								</Button>
							)}
							{router?.currentStartDate && (
								<Button className="mx-2 mt-2" onClick={() => navigate("change-plan")}>
									Change Plan
								</Button>
							)}
							{router?.currentStartDate && !router?.currentEndDate && (
								<Button className="mx-2 mt-2" onClick={() => navigate("schedule-end")}>
									Schedule End of Service
								</Button>
							)}
						</Card.Body>
					</Card>
				</Col>
				{(router?.nextStartDate || !router?.currentStartDate || router.currentEndDate) && (
					<Col>
						<Card>
							<Card.Header>Next Plan</Card.Header>
							<Card.Body>
								<Card.Text>{router?.nextTenantName}</Card.Text>
								<Card.Text>{router?.nextPlanName}</Card.Text>
								<Card.Text>{router?.nextStartDate ? `Starts on ${router?.nextStartDate}` : "No plan scheduled"}</Card.Text>
								{!router?.nextStartDate && (
									<Button className="mx-2 mt-2" onClick={() => navigate("schedule-start")}>
										Schedule Start of Service
									</Button>
								)}
								{router?.nextStartDate && (
									<Button className="mx-2 mt-2" onClick={() => navigate("cancel-start")}>
										Cancel Start of Service
									</Button>
								)}
							</Card.Body>
						</Card>
					</Col>
				)}
				<PrivateComponent groups={[Group.InternetManagementAdmin, Group.GlobalAdmin]}>
					<Col>
						<Card>
							<Card.Header>Details</Card.Header>
							<Card.Body>
								{router?.domain && <Card.Text>Domain: {router?.domain}</Card.Text>}
								<Card.Text>IP Address: {router?.ipv4Address}</Card.Text>
								<Card.Text>Username: {router?.username}</Card.Text>
								<Card.Text>Password: {router?.password}</Card.Text>
								{router?.vpnUsername && (
									<>
										<Card.Text>VPN Username: {router?.vpnUsername}</Card.Text>
										<Card.Text>VPN Password: {router?.vpnPassword}</Card.Text>
									</>
								)}
							</Card.Body>
						</Card>
					</Col>
				</PrivateComponent>
			</Row>
			<Col xs="auto">
				<Button variant="secondary" onClick={() => navigate(-1)} className="mb-4 mt-2">
					Back
				</Button>
			</Col>
		</Container>
	)
}
export default RouterPage

interface RouterQueryResponse {
	routers: RouterExtended[]
}
